<template>
  <FlotoFixedView>
    <MTab v-model="currentTab" position="left" class="px-4 flex-tab">
      <MTabPane
        key="cpu_allocation"
        :tab="$tc('cpu_allocation')"
        class="flex flex-col h-100"
      >
        <div
          v-if="currentTab === 'cpu_allocation'"
          class="w-full flex-1 min-h-full flex flex-col"
        >
          <FlotoScrollView>
            <div class="flex flex-col flex-1 px-4">
              <CPUAllocation
                :key="currentTab"
                :resource-id="resourceId"
                :module-name="moduleName"
              />
            </div>
          </FlotoScrollView>
        </div>
      </MTabPane>
      <MTabPane
        key="memory_allocation"
        :tab="$tc('memory_allocation')"
        class="flex flex-col h-100"
      >
        <div
          v-if="currentTab === 'memory_allocation'"
          class="w-full flex-1 min-h-full flex flex-col"
        >
          <FlotoScrollView>
            <div class="flex flex-col flex-1 px-4">
              <MemoryAllocation
                :key="currentTab"
                :resource-id="resourceId"
                :module-name="moduleName"
              />
            </div>
          </FlotoScrollView>
        </div>
      </MTabPane>
    </MTab>
  </FlotoFixedView>
</template>
<script>
import CPUAllocation from './cpu-allocation'
import MemoryAllocation from './memory-allocation'
export default {
  name: 'VirtualMachineTab',
  components: { CPUAllocation, MemoryAllocation },
  props: {
    resourceId: { type: Number, required: true },
    moduleName: { type: String, required: true },
  },
  data() {
    return {
      currentTab: 'cpu_allocation',
    }
  },
  methods: {
    handleTabChange(tab) {
      this.currentTab = tab
    },
  },
}
</script>
